import { cn } from "@/lib/utils";
import { cva, type VariantProps } from "class-variance-authority";
import type {
  ComponentPropsWithoutRef,
  ElementType,
  HTMLAttributes,
} from "react";
import { createElement } from "react";

const panelVariants = cva("app-panel", {
  variants: {
    variant: {
      content: "app-panel--content",
      shell: "app-panel--shell",
      compact: "app-panel--compact",
      row: "app-panel--row",
      section: "app-section-card",
    },
  },
  defaultVariants: {
    variant: "content",
  },
});

type PanelProps<T extends ElementType> = {
  as?: T;
} & VariantProps<typeof panelVariants> &
  Omit<ComponentPropsWithoutRef<T>, "as">;

export function Panel<T extends ElementType = "div">({
  as,
  className,
  variant,
  ...props
}: PanelProps<T>) {
  return createElement(as ?? "div", {
    ...props,
    className: cn(panelVariants({ variant }), className),
  });
}

export function PanelGrid({
  className,
  ...props
}: HTMLAttributes<HTMLDivElement>) {
  return <div className={cn("app-panel-grid", className)} {...props} />;
}
